import { render, staticRenderFns } from "./ReactionVector.vue?vue&type=template&id=6c62b57a&"
import script from "./ReactionVector.vue?vue&type=script&lang=ts&"
export * from "./ReactionVector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports